import { readable } from 'svelte/store';
import { ConceptData } from '../dataTypes/conceptData';
import { DeserializableMap } from '../api/deserializableMap';
import jsonConceptDatas from '../data/conceptDatas.json';
const conceptDatas = new DeserializableMap(ConceptData, (conceptData) => conceptData.id).deserialize(jsonConceptDatas);
const conceptDatasStore = readable(conceptDatas, set => {
    set(conceptDatas);
});
export { ConceptData, conceptDatasStore };
